import React, { useEffect, useState } from 'react'
import logo from '../../../assets/img/logo.png';
import AdvertisementService from '../../../services/advertisement';
import CompanyService from '../../../services/company';
import GeneralService from '../../../services/general';
import { CODES } from '../../../utils/responseCodes';
import { Toast } from '../../../utils/alerts';
import Loader from '../../components/Spinner/Loader';
import DynamicTitle from '../../../utils/DynamicTitle';
import MainInput from '../../components/general/MainInput';
import { useParams } from 'react-router-dom';
import MainSelect from '../../components/general/MainSelect';
import MainSelectPlus from '../../components/general/MainSelectPlus';
const externo = {
    numdoc: '',
    id_Documento:'',
    nombres: '',
    apePaterno: '',
    apeMaterno: '',
    celular: '',
    correo: '',
    empresa_id: ''
};

const AdvertisementsViewer = () => {
    const { fileName } = useParams();
    const [openLoader, setOpenLoader] = useState(false);
    const [messageLoader, setMessageLoader] = useState(null);
    const [companies, setCompanies] = useState(null);
    const [tipoDocumento, setTipoDocumento] = useState(null);
    const [documento, setDocumento] = useState(null);
    const [formData, setFormData] = useState(externo);
    const [documentNotFound, setDocumentNotFound] = useState(false);


    const containerStyles = {
        position: 'relative',
        width: '100%',
        maxWidth: '900px',
        backgroundColor: '#FFFFFF',
        borderRadius: '20px',
        margin: '0 auto',
        marginTop: '25px',
        border: 'solid 1px #FF9CA6',
    };

    const formStyles = {
        margin: '20px 20px 10px 20px',
        zIndex: 9999,
    };

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        await getEmpresas();getTipoDocumento();
        setOpenLoader(false);
    };

    const cleanInfo = () => {
        setFormData(externo);
    }
    const handleInputChangeDocumento = (e) => {
        const { name, value } = e.target;
    
        if (name === "numdoc") {
            const tipo = formData.id_Documento;
    
            // Solo permitir números para ciertos tipos
            const soloNumeros = [1, 2, 4, 5, 6].includes(tipo);
            if (soloNumeros && !/^\d*$/.test(value)) return;
    
            // Longitudes máximas razonables (ajustables)
            const maxLengthMap = {
                1: 8,   // DNI
                2: 12,  // CE
                3: 12,  // Pasaporte
                4: 12,  // PTP
                5: 12,  // CPP
                6: 12   // CPP
            };
    
            const maxLength = maxLengthMap[tipo] || 20;
            if (value.length > maxLength) return;
        }
    
        setFormData({ ...formData, [name]: value });
    };
    
    const getEmpresas = async () => {
        try {
            const result = await CompanyService.getEmpresas();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_empresa;
                    element.value = element.id_empresa;
                    element.label = element.desEmpresa;
                });
                setCompanies(result.data);
            }
        } catch (error) {
            console.error(`Error en getTipoEquipo: ${error}`);
        }
    };

    const getTipoDocumento = async () => {
        try {
            const result = await GeneralService.getTipoDocumento();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_Documento;
                    element.value = element.id_Documento;
                    element.label = element.Documento;
                });
                setTipoDocumento(result.data);
            }
        } catch (error) {
            console.error(`Error en getTipoDocumento: ${error}`);
        }
    };

    const downloadAdvertisement = async (e) => {
        e.preventDefault();
        if (!documento || documento.trim() === "") {
            Toast.fire({ icon: 'error', title: 'Debe ingresar un documento.' });
            return;
        }
        
        if (documento.trim().length < 8) {
            Toast.fire({ icon: 'error', title: 'El documento debe tener al menos 8 caracteres.' });
            return;
        }
        try {
            setOpenLoader(true);
            setMessageLoader('Buscando archivo ...');
            const body = { documento, advertisement: fileName };
            const result = await AdvertisementService.downloadAdvertisement(body);
            if (result.status === CODES.CREATE_201) {
                const contentType = result.headers['content-type'];
    
                if (contentType?.includes('application/json')) {
                    const text = await result.data.text();
                    const json = JSON.parse(text);
                    const icon = 'success'; 
                    const title = json.message || "Resultado desconocido";
                    Toast.fire({ icon, title });
                    return;
                }
            }
            if (result.status === CODES.SUCCESS_200) {
              
                const url = window.URL.createObjectURL(new Blob([result.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(url);

            } else if (result?.response?.status === 404) {
             
                Toast.fire({ icon: 'warning', title: 'El documento es externo, por favor registrar datos' });
                setDocumentNotFound(true);
            }
        } catch (error) {
            console.log(`Error al descargar el archivo: ${error}`);
        } finally {
            setOpenLoader(false);
            setMessageLoader(null);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            downloadAdvertisement(event);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    const registerExternal = async (e) => {
      
        if (!formData?.id_Documento) {
            Toast.fire({ icon: 'warning', title: "Debe seleccionar el tipo de documento" });
            return;
        }
    
        if (!formData?.numdoc || formData?.numdoc.trim() === '') {
            Toast.fire({ icon: 'warning', title: "Debe ingresar un número de documento" });
            return;
        }
    
        const tipo = formData.id_Documento;
        const numdoc = formData.numdoc.trim();
    
        switch (tipo) {
            case 1: // DNI
                if (numdoc.length !== 8 || !/^\d+$/.test(numdoc)) {
                    Toast.fire({ icon: 'warning', title: "El DNI debe tener exactamente 8 dígitos numéricos." });
                    return;
                }
                break;
            case 2: // CE
                if (numdoc.length < 9 || !/^\d+$/.test(numdoc)) {
                    Toast.fire({ icon: 'warning', title: "El Carnet de Extranjería debe tener al menos 9 dígitos numéricos." });
                    return;
                }
                break;
            case 3: // Pasaporte
                if (numdoc.length < 6) {
                    Toast.fire({ icon: 'warning', title: "El Pasaporte debe tener al menos 6 caracteres." });
                    return;
                }
                break;
            case 4: // PTP
            case 5: // CPP (25)
            case 6: // CPP (26)
                if (numdoc.length < 9 || !/^\d+$/.test(numdoc)) {
                    Toast.fire({ icon: 'warning', title: "Este documento debe tener al menos 9 dígitos numéricos." });
                    return;
                }
                break;
            default:
                Toast.fire({ icon: 'warning', title: "Tipo de documento no reconocido." });
                return;
        }
    
        if (!formData?.nombres || formData?.nombres.trim() === '') {
            Toast.fire({ icon: 'warning', title: "Debe ingresar sus nombres" });
            return;
        }
    
        if (!formData?.apePaterno || formData?.apePaterno.trim() === '') {
            Toast.fire({ icon: 'warning', title: "Debe ingresar su apellido paterno" });
            return;
        }
    
        if (!formData?.apeMaterno || formData?.apeMaterno.trim() === '') {
            Toast.fire({ icon: 'warning', title: "Debe ingresar su apellido materno" });
            return;
        }
    
        if (!formData?.correo || formData?.correo.trim() === '') {
            Toast.fire({ icon: 'warning', title: "Debe ingresar su correo" });
            return;
        }
    
        if (!formData?.empresa_id || formData?.empresa_id === '') {
            Toast.fire({ icon: 'warning', title: "Debe seleccionar un Cliente" });
            return;
        }
    
        try {
            setOpenLoader(true);
            setMessageLoader('Guardando información ...');
    
            const dataToSend = {
                ...formData,
                fileName: fileName
            };
    
            const result = await AdvertisementService.registerExternal(dataToSend);
    
            const icon = result.status === CODES.CREATE_201 ? 'success' : 'error';
            const title = result?.data?.message || result?.response?.data?.message || "Resultado desconocido";
    
            if (result.status === CODES.CREATE_201) cleanInfo();
            setDocumentNotFound(false);
            setFormData(externo);
            setDocumento('');
    
            Toast.fire({ icon, title });
        } catch (error) {
            console.error(`Error en registerExternal: ${error}`);
            Toast.fire({ icon: 'error', title: 'Error al guardar la información' });
        } finally {
            setOpenLoader(false);
            setMessageLoader(null);
        }
    };
    

    return (
        <div style={containerStyles}>
            <DynamicTitle title="Comparación PLAME" />
            <div style={formStyles}>
                <div className="text-center mb-2">
                    <img src={logo} alt="Logo" width={150} />
                </div>

                <div className='row justify-content-center'>
                    {!documentNotFound ? (
                        <>
                            <div className="col-md-6 mt-3">
                                <MainInput
                                    title={'Documento'}
                                    value={documento}
                                    name={'documento'}
                                    type={'text'}
                                    onChange={(e) => setDocumento(e.target.value)}
                                    handleKeyPress={handleKeyPress}
                                    required={true}
                                />
                            </div>
                            <div className="col-md-12 mt-4 mb-2 d-flex justify-content-center gap-2">
                                <button type="button" className="btn btn-primary" onClick={downloadAdvertisement}>
                                    Buscar Documento
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                         <div className="col-md-6 mt-3">
                                <MainSelectPlus
                                    title="Tipo Documento"
                                    name="id_Documento"
                                    value={formData.id_Documento}
                                    onChange={(e) =>
                                        setFormData({ ...formData, id_Documento: parseInt(e.target.value) })
                                    }
                                    options={tipoDocumento}
                                />
                            </div>
                            <div className="col-md-6 mt-3">
                                <MainInput
                                    title="Número del documento de identidad"
                                    type="text"
                                    className="form-control"
                                    name="numdoc"
                                    value={formData.numdoc}
                                    onChange={handleInputChangeDocumento}
                                />
                            </div>
                            <div className="col-md-6 mt-3">
                                <MainSelectPlus
                                    title="Cliente"
                                    name="id_empresa"
                                    value={formData.empresa_id}
                                    onChange={(e) =>
                                        setFormData({ ...formData, empresa_id: parseInt(e.target.value) })
                                    }
                                    options={companies}
                                />
                            </div>
                            <div className="col-md-6 mt-3">
                                <MainInput
                                    title="Nombres"
                                    type="text"
                                    className="form-control"
                                    name="nombres"
                                    value={formData.nombres}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-6 mt-3">
                                <MainInput
                                    title="Apellido Paterno"
                                    type="text"
                                    className="form-control"
                                    name="apePaterno"
                                    value={formData.apePaterno}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-6 mt-3">
                                <MainInput
                                    title="Apellido Materno"
                                    type="text"
                                    className="form-control"
                                    name="apeMaterno"
                                    value={formData.apeMaterno}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-6 mt-3">
                                <MainInput
                                    title="Celular"
                                    type="text"
                                    className="form-control"
                                    name="celular"
                                    value={formData.celular}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-6 mt-3">
                                <MainInput
                                    title="Correo"
                                    type="email"
                                    className="form-control"
                                    name="correo"
                                    value={formData.correo}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="col-md-12 mt-4 d-flex justify-content-center gap-2">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setDocumentNotFound(false);
                                        setFormData(externo);
                                        setDocumento('');
                                    }}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => {
                                        registerExternal();
                                    }}
                                >
                                    Guardar
                                </button>
                            </div>
                        </>
                    )}
                </div>

            </div>
            <Loader open={openLoader} message={messageLoader} />
        </div>
    )
}

export default AdvertisementsViewer;
